import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IndexationType } from "../../../../../../Wrap/Models/Models/Processes/Quote/Pension/IndexationType";

export const PPToProductSteppersMap = {
    investmentDetails: "investment Details",
    review: "Review",
    documentsAndDeclarations: "Documents / declarations",
    confirm: "Confirmation",
};

export const productMap = {
    [SubAccountType.Sipp]: "SIPP",
    [SubAccountType.StocksIsa]: "ISA Stocks & Shares",
    [SubAccountType.PersonalPortfolio]: "Personal Portfolio",
    [SubAccountType.Npr]: "abrdn SIPP",
};

export const FinancialAdviceMap = {
    true: "Yes",
    false: "No",
};

export const PPToProductLables = {
    transferTo: "Which account do you want to transfer to?",
    transferIsaAmount: "Amount",
    transferSippAmount: "Amount",
    investmentsToSell: "Investments to sell from Personal Portfolio",
    withdrawalMethod: "Withdrawal method",
    investmentsToBuyIn: "Investments to buy in ",
    investmentsToBuy: "Investments to buy",
    reuseInvestment: "Use existing assets",
};

export const PPToProducErrorMessage = {
    toIsa:
        "There is currently no active ISA account. Please create one before continuing with the PP to S&S ISA Application.",
    toSipp:
        "There is currently no active abrdn SIPP account. Please create one before continuing with the PP to abrdn SIPP Application.",
    noSellableHolding:
        "There is currently no sellable holding. Please make sure the current PP account has enough sellable holdings.",
};
